
/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 24/01/2025
*/

import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { pink } from '@mui/material/colors';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import contactDialogImage from '../../assets/images/product/ContactBackground.png';
import { useCreateMessageMutation } from '../../services/issueService';
import ContactBtnDialog from '../contact/contactBtnDialog';
import Success from '../contact/Success';
import Styles from "./plans.module.css";

export default function PlansCard() {


  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [data, setData] = useState({});
  const [createMessage] = useCreateMessageMutation();
  const handleClickOpen = (PlanType) => {
    setData({ ...data, message: PlanType });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const respond = await createMessage(data).unwrap();
      setOpen(false);
      setOpenSuccess(true);
    } catch (err) {
      console.error("Failed to save the Message: ", err);
    }
  }

  const plans = [
    {
      id: '1',
      type: 'Silver',
      Price: '0',
      points1: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points2: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points3: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points4: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points4Value: '200',
      points5: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points6: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points7: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points8: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points9: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points10: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points11: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points12: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points13: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points14: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points15: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points16: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,

    },
    {
      id: '2',
      type: 'Platinum',
      Price: '9',
      points1: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points2: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points3: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points4: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points4Value: '2500',
      points5: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points6: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points7: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points8: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points9: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points10: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points11: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points12: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points13: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points14: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points15: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points16: <TaskAltIcon color="success" className={Styles.planPoints} />,
    },
    {
      id: '3',
      type: 'Gold',
      Price: '9',
      points1: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points2: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points3: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points4: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points4Value: '1000',
      points5: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points6: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points7: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points8: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points9: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points10: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points11: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points12: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points13: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points14: <TaskAltIcon color="success" className={Styles.planPoints} />,
      points15: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
      points16: <HighlightOffIcon sx={{ color: pink[500] }} className={Styles.planPoints} />,
    },


  ]

  return (
    <>
      <div className={Styles.planCardOuter}>
        <Typography className={Styles.description} >Pricing</Typography>
        <Typography className={Styles.topic}>Choose the right plan</Typography>
        <div>
          {/* <div className={Styles.PlanCardContainerouter}> */}
          <div className={Styles.PlanCardContainer}>
            <div className={Styles.planCardCom}>
              {plans.map(plan => (
                <Card className={Styles.planCard} key={plan.id}>
                  <div className={Styles.planCardCircle}></div>
                  <CardContent className={Styles.planCardContent}>
                    {/* <Typography sx={{ mb: 1.5 }} className={Styles.planPoints} >{plan.type}</Typography> */}
                    <Typography variant="h5" className={Styles.planPointsHader}>
                      {plan.type}
                    </Typography>
                    <Box sx={{ alignItems: 'start' }} className={Styles.planTextList}>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points1}  Unlimited No Of Products
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points2}  All featurs in Ecommers module
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points3}  Domain Registration
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points4} {plan.points4Value} No Of Emails per Month
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points5}  Mobile App - Android & Apple
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points7}  Web Point of Sale
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points8}  Mobile Point of Sale
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points9}  CRM Module
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points10}  Inventory/Warehouse management System
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points11}  Issue management system
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points12}  Interactive Chat
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points13} 24*7 Extended Support
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points14}  Business Improvement Ideas
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points15}  Automatic social media posting
                      </Typography>
                      <Typography variant="body2" className={Styles.planPoints}>
                        {plan.points16}  Integrated Financial system
                      </Typography>

                    </Box>

                    <Button onClick={() => handleClickOpen(plan.type)} size="small" variant="contained" sx={{ borderRadius: 1, paddingLeft: 3, paddingRight: 3, paddingTop: 1, paddingBottom: 1 }} className={Styles.CardSubscribeBtn}  >Choose Plan</Button>
                  </CardContent>

                </Card>
              ))}

              <Dialog
                open={open}
                onClose={handleClose}
                className={Styles.btnMainDialogComp}
                slotProps={{
                  paper: {
                    component: 'form',
                    onSubmit: (event) => {
                      event.preventDefault();
                      const formData = new FormData(event.currentTarget);
                      const formJson = Object.fromEntries(formData.entries());
                      const email = formJson.email;
                      handleClose();
                    },
                  },
                }}
              >
                <DialogTitle>Welcome To N-Ach</DialogTitle>
                <DialogContent className={Styles.btnContentDialogContent}>
                  <DialogContentText>
                    <img src={contactDialogImage} className={Styles.contactDilaogImage}></img>
                    <br></br>
                    Thank you for choosing us! <br></br>
                    Please enter your email and contact number, and we'll reach out to you shortly.
                  </DialogContentText>
                  <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="name"
                    name="email"
                    label="Email Address"
                    type="email"
                    fullWidth
                    variant="standard"
                    onChange={(e) => setData((prevData) => ({ ...prevData, email: e.target.value }))}
                  />
                  <TextField
                    autoFocus
                    required
                    margin="dense"
                    label="Your mobile number" type='number'
                    id="name"
                    name="mobile"
                    fullWidth
                    variant="standard"
                    onChange={(e) => setData((prevData) => ({ ...prevData, mobileNumber: e.target.value }))}
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button type='submit' variant='contained' className={Styles.dialogSendButton} onClick={handleSubmit}> Send </Button>

                </DialogActions>
              </Dialog>

              <Success
                open={openSuccess}
                onClose={() => {
                  setOpenSuccess(false)
                  window.location.reload()
                }} />
            </div>

            {/* <div className={Styles.plancardBackgroud}>
              <Box>
                <Typography variant='h4' className={Styles.planSectionContactTxt}> Tailor your perfect plan! <br></br>Let's chat—contact us today to get started.</Typography>
                <ContactBtnDialog />
              </Box>

            </div> */}
          </div>
          {/* </div> */}
        </div>
      </div>
    </>

  );
}
